/* eslint-disable no-restricted-imports */
import {bytesToGB, getBrowserName} from '../utils';

type TProps = {
	totalMemoryUsed: number;
};

const MemoryUsed = ({totalMemoryUsed}: TProps) => (
	<>
		{getBrowserName() === 'Chrome' && (
			<p>
				<small data-testid="memory">{bytesToGB(totalMemoryUsed)} GB used</small>
			</p>
		)}
	</>
);

export default MemoryUsed;
